import React from 'react';

export default () => (
    <svg width="18" height="18" viewBox="0 0 513 513" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g>
            <path d="M508.885 493.784L353.109 338.008C385.45 302.083 405.333 254.723 405.333 202.669C405.333 90.925 314.41 0.00195312 202.666 0.00195312C90.922 0.00195312 0 90.925 0 202.669C0 314.413 90.923 405.336 202.667 405.336C254.72 405.336 302.08 385.453 338.006 353.091L493.782 508.867C495.873 510.958 498.603 512.003 501.334 512.003C504.065 512.003 506.795 510.958 508.886 508.888C513.045 504.707 513.045 497.965 508.885 493.784ZM202.667 384.003C102.678 384.003 21.334 302.659 21.334 202.67C21.334 102.681 102.677 21.336 202.667 21.336C302.657 21.336 384 102.68 384 202.669C384 302.658 302.656 384.003 202.667 384.003Z" fill="black"/>
        </g>
    </svg>
)
